import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/my/absences")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({ getTitle: () => t("MyAbsences") }),
})
